import Vue from 'vue';

export default ({ $tools }) => {
  Vue.filter('moneyWithDecimal', num => {
    if (num === null || num === undefined || isNaN(Number(num))) {
      return `0.00 ${$tools.currency.local}`;
    }

    const [integerPart, rawDecimal = ''] = String(num).split('.');
    const decimalPart = rawDecimal.slice(0, 2).padEnd(2, '0');

    return `${integerPart}.${decimalPart} ${$tools.currency.local}`;
  });
};
